import {getField, updateField} from 'vuex-map-fields'
import BaseStore from './baseStore'
import BaseDirtyFields from './baseDirtyFields'
import {LoadAreaPlot, LoadSpreadPlot, TreeLoadPlot, WindForcePlot} from "@/plotData/uniformLoads";
import {lineString, lineIntersect} from "@turf/turf"
import {generateMultipleItemOverview} from "@/store/baseOverview";


export const namespaced = true;

let baseUrl = '/tree_loads/';

const baseStore = new BaseStore(baseUrl);
const baseDirtyFields = new BaseDirtyFields();
const baseOverview = generateMultipleItemOverview({
    itemFilter: (treeLoad, stabSchematisationStage) => treeLoad.stage === stabSchematisationStage.id,
    duplicationCheckFunc: (treeload, stabSchematisationStageId) => treeload.stage === stabSchematisationStageId,
})


const getDefaultState = () => {
    return {
        ...structuredClone(baseStore.state),
        ...structuredClone(baseDirtyFields.state),
    };
};
export const state = {
    ...getDefaultState(),
    ...structuredClone(baseOverview.state),
};


export const mutations = {
   ...baseStore.mutations,
    ...baseDirtyFields.mutations,
    ...baseOverview.mutations,
    updateField,
    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    },
}

export const actions = {
     ...baseStore.actions,
    ...baseDirtyFields.actions,
    ...baseOverview.actions,
    resetState({commit}) {
        commit("RESET_STATE");
    },
}

export const getters = {
    ...baseOverview.getters,
    getField,
    getPlotData: (state, getters, rootState, rootGetters) => (stabSchematisationStage = null) => {
        let storeName = 'treeLoads'
        let polygon = []
        const topoProfileGeometry = rootGetters["topoProfilePoint/getTopoProfileGeometry"](stabSchematisationStage);
        const plotDataMaxY = rootGetters["topoProfilePoint/getPlotDataMaxY"](stabSchematisationStage);
        const plotDataMinY = rootGetters["topoProfilePoint/getPlotDataMinY"](stabSchematisationStage);
        const items = getters.getItemsByStabSchematisationStage(stabSchematisationStage);
        topoProfileGeometry && topoProfileGeometry.length ? items.forEach(item => {
          let itemCenter = item.top_of_tree_x
          let intersectLineCenter = [[itemCenter, plotDataMinY], [itemCenter, plotDataMaxY]]
          let itemStart = item.top_of_tree_x - item.width_root_zone / 2;
          let itemEnd = item.top_of_tree_x + item.width_root_zone / 2;
  
          const [intersectLineStart, intersectLineEnd] = getters.getInterSectionLines({itemStart, itemEnd, stabSchematisationStage});
          let pointStart = getters.calculatePoint(topoProfileGeometry, intersectLineStart);
          let pointEnd = getters.calculatePoint(topoProfileGeometry, intersectLineEnd);
          let pointCenter = getters.calculatePoint(topoProfileGeometry, intersectLineCenter);
          let topOfTreeY = pointCenter[1] + item.top_of_tree_z
          let plotTreeItem = new TreeLoadPlot(item, 'tree_load_')
          plotTreeItem.storeName = storeName
          plotTreeItem.x = [pointCenter[0], pointCenter[0]]
          plotTreeItem.y = [pointCenter[1], topOfTreeY]
  
          polygon.push(plotTreeItem)
  
          let height = -1
  
          let loadWindForce = pointCenter[0] - item.wind_force
          let plotWindForceItem = new WindForcePlot(item, 'wind_force_')
          plotWindForceItem.x = [pointCenter[0] - item.wind_force / 10, loadWindForce]
          plotWindForceItem.y = [topOfTreeY, topOfTreeY]
          plotWindForceItem.storeName = storeName
  
          polygon.push(plotWindForceItem)
  
          let plotAreaItem = new LoadAreaPlot(item, 'tree_load_', 'toself', 'grey') // TODO refactor more when
          plotAreaItem.extractPolygonFromLine(pointStart, pointEnd, height, topoProfileGeometry);
          plotAreaItem.storeName = storeName
          polygon.push(plotAreaItem)
  
          let spread = item.spread - 45
          let plotSpreadItemStart = new LoadSpreadPlot(item)
          let plotSpreadItemEnd = new LoadSpreadPlot(item, true)
          plotSpreadItemStart.create(pointStart, spread, height)
          plotSpreadItemEnd.create(pointEnd, spread, height)
          plotSpreadItemStart.storeName = storeName
          plotSpreadItemEnd.storeName = storeName
          polygon.push(plotSpreadItemStart, plotSpreadItemEnd)
        }) : null;
        return polygon;
      },
      
    getInterSectionLines: (state, getters, rootState, rootGetters) => ({itemStart, itemEnd, stabSchematisationStage = null}) => {
        const plotDataMaxY = rootGetters["topoProfilePoint/getPlotDataMaxY"](stabSchematisationStage);
        const plotDataMinY = rootGetters["topoProfilePoint/getPlotDataMinY"](stabSchematisationStage);
        const plotDataMaxX = rootGetters["topoProfilePoint/getPlotDataMaxX"](stabSchematisationStage);
        const plotDataMinX = rootGetters["topoProfilePoint/getPlotDataMinX"](stabSchematisationStage);
        let xStart = itemStart < plotDataMinX ? plotDataMinX : itemStart
        let xEnd = itemEnd > plotDataMaxX ? plotDataMaxX : itemEnd
        let intersectLineStart = [[xStart, plotDataMinY], [xStart, plotDataMaxY]]
        let intersectLineEnd = [[xEnd, plotDataMinY], [xEnd, plotDataMaxY]]
        return [intersectLineStart, intersectLineEnd]
      },
    calculatePoint: () => (topoProfileGeometry, line2) => {
        var line1 = lineString(topoProfileGeometry);
        var intersects = lineIntersect(line1, lineString(line2));
        return intersects.features[0].geometry.coordinates
      },
}



